import { render, staticRenderFns } from "./message-patterns-readonly.vue?vue&type=template&id=0baa9fb4&scoped=true&"
import script from "./message-patterns-readonly.vue?vue&type=script&lang=js&"
export * from "./message-patterns-readonly.vue?vue&type=script&lang=js&"
import style0 from "./message-patterns-readonly.vue?vue&type=style&index=0&id=0baa9fb4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0baa9fb4",
  null
  
)

export default component.exports